module.exports = __webpack_public_path__ + "Lato-Regular.122dd68d69fe9587e062.ttf";


//////////////////
// WEBPACK FOOTER
// /mnt/disk/stratbox.dev/src/assets/fonts/Lato/Lato-Regular.ttf
// module id = ../../../../../src/assets/fonts/Lato/Lato-Regular.ttf
// module chunks = styles